import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import SelectInput from '../../components/Inputs/SelectInput';
import Toast from '../../components/Toasts/Toast';
import { objectsConstants } from '../../constants/objects.constants';
import { clienteService } from '../../services/cliente.service';
import { defaultService } from '../../services/defaultService';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';

import * as Yup from 'yup';
import CpfInput from '../../components/Inputs/CpfInput';
import { isSudo } from '../../helpers/permissions.helper';
import { confirmAlert } from 'react-confirm-alert';
import { isValidCPF } from '../../components/Utils/cpfUtils';

const getValidationSchema = (isSudo) =>
  Yup.object().shape({
    nome: Yup.string().required('Nome é obrigatório'),
    cpf: Yup.string()
      .required('CPF é obrigatório')
      .test('cpf-valido', 'CPF inválido', (value) => {
        if (!value) return false;
        return isValidCPF(value);
      }),
    email: Yup.string()
      .email('E-mail inválido')
      .required('E-mail é obrigatório'),
    perfis: Yup.array()
      .of(
        Yup.string().oneOf([
          'ADMIN',
          'APROVADOR',
          'SOLICITANTE',
          'ADMIN_BIO', // adiciona aqui também se ainda não estiver
        ])
      )
      .min(1, 'Selecione pelo menos um perfil')
      .required('Perfil é obrigatório'),

    cliente: Yup.mixed()
      .nullable()
      .when(['perfis'], {
        is: (perfis) =>
          isSudo && (!Array.isArray(perfis) || !perfis.includes('ADMIN_BIO')),
        then: Yup.object()
          .nullable()
          .required('Cliente é obrigatório'),
        otherwise: Yup.mixed().nullable(),
      }),
  });

class UsuarioEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.state = {
      entity: {
        cliente: isSudo() ? null : user.cliente,
      },
    };
  }

  componentDidMount() {
    console.log(this.props);
    if (this.props.match.params.id) {
      userService.doGet(this.props.match.params.id).then(
        (response) => {
          let usuario = response.data;
          const isSudo =
            this.props.user && this.props.user.perfis.includes('SUDO');
          if (!isSudo && this.props.user.cliente) {
            usuario.cliente = this.props.user.cliente;
          }
          this.setState({ entity: usuario }, () => {});
        },
        (error) => {
          console.log('error');
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  }

  render() {
    const { entity } = this.state;
    const isSudo = this.props.user && this.props.user.perfis.includes('SUDO');

    const isEdit = !!this.state.entity.id;

    const mesmoUsuario = this.state.entity.id == this.props.user.id;

    const perfisOptions = isSudo
      ? objectsConstants.PERFIS
      : objectsConstants.PERFIS.filter((p) => p.value !== 'ADMIN_BIO');

    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Usuários" subTitle=" " canBack={true} />
        <Formik
          validationSchema={getValidationSchema(isSudo)}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            let clientEntity = values;
            if (_.get(clientEntity, '_links.self.href')) {
              _.set(
                clientEntity,
                'id',
                defaultService.getIdFromUrl(
                  _.get(clientEntity, '_links.self.href')
                )
              );
            }
            _.set(clientEntity, 'authorities', null);

            userService
              .doSave(clientEntity)
              .then((response) => {
                console.log(response);
                let id = response.data.id;
                values.id = id;
                this.props.history.push('/usuario');
                actions.setSubmitting(false);
                this.props.success({ message: 'Usuario salvo com sucesso.' });
              })
              .catch((e) => {
                actions.setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="flex-column">
                <Toast />
                <div className="cardSeculus d-flex flex-column mb-0">
                  <div className="topoCard d-flex flex-column flex-sm-row">
                    <h3 className="flex-grow-1">Usuários</h3>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-12 col-lg-12">
                      <label>
                        Nome<span style={{ color: 'red' }}> *</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.nome ? 'error' : ''}`}
                        name="nome"
                        placeholder="Digite o nome completo ou nome fantásia"
                        value={values.nome}
                        onChange={(e) => {
                          const { name, value } = e.currentTarget;

                          setFieldValue(name, value);
                        }}
                      />
                    </div>
                    {/* {Object.keys(errors).length > 0 && (
                      <pre style={{ color: 'red' }}>
                        {JSON.stringify(errors, null, 2)}
                      </pre>
                    )} */}
                    <div className="form-group col-12 col-lg-12">
                      <CpfInput
                        placeholder="Digite o CPF"
                        erroMensagem={errors.cpf}
                        required
                        id={'cpf'}
                        name="cpf"
                        value={values.cpf}
                        onChange={setFieldValue}
                        noSize={true}
                        label={' CPF'}
                      />

                      {isSudo && (
                        <FormSelectInput
                          name="cliente"
                          id={'cliente'}
                          label="Cliente"
                          placeholder="Selecione o cliente"
                          valueKey="id"
                          labelKey="label"
                          noSize={true}
                          required={
                            !values.perfis ||
                            !values.perfis.includes('ADMIN_BIO')
                          }
                          returnFullObject={true}
                          isMulti={false}
                          searchable={false}
                          allowSelectAll={false}
                          service={clienteService.findAll}
                          onChange={(name, value) => {
                            console.log(value);

                            setFieldValue(name, value);
                          }}
                          value={values.cliente}
                          messageValidate={_.get(errors, `cliente`)}
                        />
                      )}
                    </div>

                    <div className="form-group col-12 col-md-6 ">
                      <label>
                        E-mail <span style={{ color: 'red' }}> *</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.email ? 'error' : ''
                        }`}
                        name="email"
                        placeholder="Digite o e-mail"
                        value={values.email}
                        onChange={handleChange}
                        autoComplete="new-email"
                      />
                    </div>
                    <div className="form-group col-12 col-md-6 ">
                      <label>Password </label>
                      <input
                        type="password"
                        className={`form-control ${
                          errors.senha ? 'error' : ''
                        }`}
                        name="senha"
                        placeholder="Digite a senha"
                        value={values.senha}
                        onChange={handleChange}
                        autoComplete="new-password"
                      />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <SelectInput
                        id="perfis"
                        name="perfis"
                        options={perfisOptions}
                        label="Perfis do usuário"
                        labelKey="name"
                        valueKey="value"
                        value={objectsConstants.PERFIS.filter((opt) =>
                          Array.isArray(values.perfis)
                            ? values.perfis.includes(opt.value)
                            : false
                        )}
                        returnFullObject={true}
                        isMulti={true}
                        required={true}
                        searchable={true}
                        allowSelectAll={true}
                        onChange={(name, selectedOptions) => {
                          // Converte para array de strings antes de setar no Formik
                          const perfis = Array.isArray(selectedOptions)
                            ? selectedOptions.map((s) => s.value)
                            : [];
                          setFieldValue(name, perfis);
                        }}
                        messageValidate={_.get(errors, 'perfis')}
                      />
                    </div>
                  </div>

                  <div className="d-flex flex-row flex-sm-row ">
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="button"
                        className="btn btn-secondary btn30 white"
                        disabled={isSubmitting}
                        onClick={() => this.props.history.goBack()}
                      >
                        Cancelar
                      </button>
                    </div>
                    {isEdit && (
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-danger btn30"
                          disabled={isSubmitting || mesmoUsuario}
                          onClick={() => {
                            confirmAlert({
                              customUI: ({ onClose }) => (
                                <div className="custom-confirm-alert">
                                  <h2>Confirmar exclusão</h2>
                                  <p>
                                    Você tem certeza que deseja excluir este
                                    Usuário?
                                  </p>
                                  <div className="d-flex justify-content-around mt-4">
                                    <button
                                      className="btn btn-secondary btn30 white"
                                      onClick={onClose}
                                    >
                                      Não
                                    </button>
                                    <button
                                      className="btn btn-danger btn30"
                                      onClick={async () => {
                                        try {
                                          await userService.doDelete(values.id);
                                          this.props.success({
                                            message:
                                              'Usuário excluído com sucesso.',
                                          });
                                          this.props.history.push('/usuario');
                                          onClose();
                                        } catch (e) {
                                          console.error(e);
                                          this.props.error({
                                            message:
                                              'Erro ao excluir o Usuário',
                                          });
                                          onClose();
                                        }
                                      }}
                                    >
                                      Sim
                                    </button>
                                  </div>
                                </div>
                              ),
                            });
                          }}
                        >
                          Excluir
                        </button>
                      </div>
                    )}
                    <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                      <button
                        type="submit"
                        className="btn btn-secondary btn30 green"
                        disabled={isSubmitting}
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;

  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  {
    forwardRef: true,
  }
)(UsuarioEdit);
